<template functional>
  <nav class="nav level" v-bind="data.attrs">
    <slot />
  </nav>
</template>

<script>
export default {
  name: 'Nav'
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/components/level';

.nav {
  height: 40px;
}
</style>
